import { FEATURE_LOYALTY_UI_SINGLETON } from 'features/content/hooks/use-feature-loyalty-ui';

import { useFeatureLoyaltyUiNotEnrolledQuery } from 'generated/sanity-graphql';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

export const useFeaturesLoyaltyNotEnrolled = () => {
  const isDesktop = useIsDesktopBreakpoint();

  const { data, loading, refetch } = useFeatureLoyaltyUiNotEnrolledQuery({
    variables: { featureLoyaltyUIId: FEATURE_LOYALTY_UI_SINGLETON },
  });

  const { LoyaltyUI } = data || {};

  const getNotEnrolledData = () => {
    const [desktopState, mobileState] = [
      LoyaltyUI?.notEnrolledState,
      LoyaltyUI?.notEnrolledStateMobile,
    ];

    if (isDesktop) {
      return desktopState || mobileState;
    }
    return mobileState || desktopState;
  };

  return {
    data: getNotEnrolledData(),
    loading,
    refetch,
  };
};
